import React from "react";

const WhyChooseUs = () => {
  return (
    <div
      className="section-full site-bg-white py-3 twm-w-chooseus2-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="container">
        <div className="row twm-w-chooseus2-section">

          {/* Left Content */}
          <div className="col-lg-5 col-md-12">

            <div className="section-head left">
              <div className="twm-sm-title left">Why Choose Velocity Cab</div>
              <h2 className="twm-large-title site-text-dark">Reliable Cab Services You Can Trust</h2>

              {/* <div className="section-head-detail">
                We provide safe, affordable, and comfortable cab services with a focus on customer satisfaction and reliable travel experience.
              </div> */}
            </div>

            <div className="twm-list-icon-style2">
              <ul>

                {/* Item 1 */}
                <li>
                  <div className="twm-list-icon-style-bx2">
                    <div className="twm-icon-bx">
                      <span>
                        <img src="/images/w-choose-icon/icon-1.png" alt="Affordable" />
                      </span>
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Affordable Pricing</h3>
                      <p>
                        Get budget-friendly rides with transparent pricing and no hidden charges for every journey.
                      </p>
                    </div>
                  </div>
                </li>

                {/* Item 2 */}
                <li>
                  <div className="twm-list-icon-style-bx2">
                    <div className="twm-icon-bx">
                      <span>
                        <img src="/images/w-choose-icon/icon-2.png" alt="Flexible Booking" />
                      </span>
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Easy Booking</h3>
                      <p>
                        Book your cab quickly with simple steps and enjoy flexible options for local and outstation trips.
                      </p>
                    </div>
                  </div>
                </li>

                {/* Item 3 */}
                <li>
                  <div className="twm-list-icon-style-bx2">
                    <div className="twm-icon-bx">
                      <span>
                        <img src="/images/w-choose-icon/icon-3.png" alt="Quality Service" />
                      </span>
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Quality Service</h3>
                      <p>
                        Travel in clean, well-maintained vehicles driven by professional and experienced drivers.
                      </p>
                    </div>
                  </div>
                </li>

                {/* Item 4 */}
                <li>
                  <div className="twm-list-icon-style-bx2">
                    <div className="twm-icon-bx">
                      <span>
                        <img src="/images/w-choose-icon/icon-4.png" alt="Pickup Drop" />
                      </span>
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Pickup & Drop</h3>
                      <p>
                        Enjoy convenient doorstep pickup and drop services with safety, comfort, and on-time travel.
                      </p>
                    </div>
                  </div>
                </li>

              </ul>
            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-7 col-md-12">
            <div className="twm-w-chooseus2-media">

              <div className="twm-media">
                <img src="/images/need-h-pic2.jpeg" alt="Cab Service" />
              </div>

              <div className="twm-need-help-bx2">
                <div className="twm-need-help-content">
                  <span>Need a ride?</span>
                  <h3 className="twm-title">+91 9136271336</h3>
                </div>

                <div className="twm-need-help-icon">
                  <img src="/images/24-clock.png" alt="24/7 Service" />
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;